import ControlledLabeledInput, { LabeledInput } from "app/ReactUseForm/ControlledLabeledInput";
import { validationErrorToFormError } from "app/ReactUseForm/ErrorValidation";
import React from "react";
import { useController } from "react-hook-form";
import { useIntl } from "react-intl";
import { Form, Input } from "semantic-ui-react";


export default function WorklistIntervalInput<T>({control,
    name,
    rules,
    defaultValue,
    shouldUnregister,
    disabled,
    label,
    ...inputProps}: React.ComponentProps<typeof ControlledLabeledInput<T>>) {
      const intl = useIntl();
      const { field, fieldState } = useController({
        control,
        name,
        rules,
        defaultValue,
        shouldUnregister,
        disabled,
      });
    
      const error = validationErrorToFormError(fieldState.error, rules, intl);
    
      return (
        <Form.Field
          {...inputProps}
          {...rules}
          as="label"
          error={error}
          control={LabeledInput}
          required={!!rules?.required}
          value={Math.floor(Number(field.value) / 60)}
          onBlur={field.onBlur}
          onChange={
            ((e, { value }) =>
              field.onChange(
                Number(value) * 60
              )) as React.ComponentProps<typeof Input>['onChange']
          }
          name={field.name}
          disabled={field.disabled}
          input={<input ref={field.ref} type={inputProps.type} />}
          labelInput={label}
        />
      );
}